// @flow

const PrimaryPalette = {
  white: '#FFFFFF',
  lightestGrey: '#F9FAF9',
  lightGrey: '#EFF1F0',
  mediumGrey: '#E0E5E3',
  darkGrey: '#CCD4D1',
  darkerGrey: '#677D76',
  darkestGrey: '#526B63',

  linkGreen: '#078361',

  darkGreen: '#008561',
  mediumGreen: '#24A47F',
  lightGreen: '#4CB398',
  extraLightGreen: '#F3FFFB',

  mediumEvergreen: '#15372C',
  lightEvergreen: '#335247',

  darkPoppy: '#B52617',
  mediumPoppy: '#D8372A',
  lightPoppy: '#E3564B',
  extraLightPoppy: '#FFF7F8',

  darkIris: '#054AB2',
  mediumIris: '#3574D6',
  lightIris: '#578BDD',
  lighterIris: '#D6E6FF',
  extraLightIris: '#ECF3FF',

  darkYellow: '#F2CD00',
  mediumYellow: '#FFE607',
  lightYellow: '#FFF9C1',
  extraLightYellow: '#FFFBD7',
};

export type Color = $Values<typeof PrimaryPalette>;

export default PrimaryPalette;
